<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="800px"
    scrollable
    class="scrollDesign"
  >
    <v-card>
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text"
          >{{
            $t(
              'students.massive_upload.step_3.modal_upload_info.import_students_and_tutors'
            )
          }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12>
            <v-card-title
              class="headline lighten-2"
              primary-title
              style="text-align: center; justify-content: center"
            >
              {{
                $t(
                  'students.massive_upload.step_3.modal_upload_info.following_data_will_be_imported'
                )
              }}<br />
              <strong style="justify-content: center"
                >{{ update }} Alumnos actualizados - {{ removed }} Alumnos de
                baja - {{ created }} Alumnos de alta - {{ ignored }} Alumnos sin
                cambios</strong
              >
              <v-spacer></v-spacer>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text
              style="justify-content: center; text-align: -webkit-center"
            >
              <strong>
                {{
                  $t(
                    'students.massive_upload.step_3.modal_upload_info.important'
                  )
                }}
              </strong>
              <br />

              {{
                $t(
                  'students.massive_upload.step_3.modal_upload_info.important_description'
                )
              }}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions style="justify-content: center">
              <v-btn
                color="primary"
                small
                @click="close"
                style="padding: 17px; margin: 17px"
              >
                {{
                  $t('students.massive_upload.step_3.modal_upload_info.cancel')
                }}
              </v-btn>
              <v-btn
                color="black"
                small
                @click="imput"
                style="
                  padding: 17px;
                  margin: 17px;
                  color: white;
                  background: black;
                "
              >
                {{
                  $t('students.massive_upload.step_3.modal_upload_info.upload')
                }}
              </v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    update: 0,
    removed: 0,
    created: 0,
    ignored: 0,
  }),
  props: ['value', 'title', 'description', 'status'],

  methods: {
    close() {
      this.$emit('input', !this.value)
    },

    imput() {
      this.$emit('input', !this.value)
      this.$emit('updateStd')
    },
  },

  watch: {
    value() {
      this.update = this.status.update
      this.removed = this.status.removed
      this.created = this.status.created
      this.ignored = this.status.ignored
    },
  },
}
</script>

<style></style>
